import * as React from "react";
import { Card, Grid, CircularProgress, Icon } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useGetAntecedentesQuery } from "services/escuela/antecedentes_estudiantil/usecases/getAntecedentes";

const DetailItem = ({ label, value }) => (
  <MDBox mb={1} width="100%" pr={1}>
    <MDTypography
      variant="caption"
      fontWeight="bold"
      color="text"
      display="block"
      gutterBottom
    >
      {label}
    </MDTypography>
    <MDTypography
      variant="body2"
      fontWeight="regular"
      color="dark"
      sx={{
        display: "block",
        width: "100%",
        wordBreak: "break-word",
        overflowWrap: "anywhere",
        whiteSpace: "normal",
        lineHeight: 1.4,
      }}
    >
      {value || "-"}
    </MDTypography>
  </MDBox>
);

const AntecedentesShow = ({ rowData, stretch = false }) => {
  const { data, isLoading, isError } = useGetAntecedentesQuery({
    filter_params: {
      estudiante: rowData.id,
      query:
        "{id,institucion_procedencia,tipo_estudio_antecedente{descripcion},entidad_federativa_antecedente{entidad},fecha_inicio,fecha_terminacion,no_cedula}",
    },
    shape: {
      id: "id",
      institucion_procedencia: "institucion_procedencia",
      tipo_estudio_antecedente: "tipo_estudio_antecedente.descripcion",
      entidad_federativa_antecedente: "entidad_federativa_antecedente.entidad",
      fecha_inicio: "fecha_inicio",
      fecha_terminacion: "fecha_terminacion",
      no_cedula: "no_cedula",
    },
  });

  const antecedentes = data?.results || data || [];

  return (
    <MDBox mt={2} mb={2}>
      <Card sx={{ overflow: "visible" }}>
        <MDBox p={3}>
          <MDBox display="flex" alignItems="center" mb={2}>
            <Icon color="info" sx={{ mr: 1 }}>
              school
            </Icon>
            <MDTypography variant="h6" fontWeight="medium">
              Antecedentes Académicos
            </MDTypography>
          </MDBox>

          {isLoading ? (
            <MDBox display="flex" justifyContent="center" p={2}>
              <CircularProgress color="inherit" />
            </MDBox>
          ) : isError ? (
            <MDTypography variant="body2" color="error">
              Error al cargar los antecedentes
            </MDTypography>
          ) : antecedentes.length === 0 ? (
            <MDTypography variant="body2" color="text">
              No tiene antecedentes registrados.
            </MDTypography>
          ) : (
            antecedentes.map((antecedente, index) => (
              <MDBox
                key={antecedente.id || index}
                mb={index !== antecedentes.length - 1 ? 3 : 0}
              >
                {index > 0 && (
                  <MDBox
                    sx={{
                      width: "100%",
                      height: "1px",
                      backgroundColor: "#344767",
                      opacity: 0.2,
                      my: 2,
                    }}
                  />
                )}
                <Grid container spacing={2}>
                  <Grid item xs={12} md={stretch ? 4 : 12}>
                    <DetailItem
                      label="Institución de Procedencia"
                      value={antecedente.institucion_procedencia}
                    />
                  </Grid>
                  <Grid item xs={6} md={stretch ? 4 : 6}>
                    <DetailItem
                      label="Tipo de Estudio"
                      value={antecedente.tipo_estudio_antecedente}
                    />
                  </Grid>
                  <Grid item xs={6} md={stretch ? 4 : 6}>
                    <DetailItem
                      label="Entidad Federativa"
                      value={antecedente.entidad_federativa_antecedente}
                    />
                  </Grid>

                  <Grid item xs={6} md={stretch ? 4 : 6}>
                    <DetailItem
                      label="Fecha de Inicio"
                      value={antecedente.fecha_inicio}
                    />
                  </Grid>
                  <Grid item xs={6} md={stretch ? 4 : 6}>
                    <DetailItem
                      label="Fecha de Terminación"
                      value={antecedente.fecha_terminacion}
                    />
                  </Grid>
                  <Grid item xs={6} md={stretch ? 4 : 12}>
                    <DetailItem
                      label="Número de Cédula"
                      value={antecedente.no_cedula}
                    />
                  </Grid>
                </Grid>
              </MDBox>
            ))
          )}
        </MDBox>
      </Card>
    </MDBox>
  );
};

export default AntecedentesShow;
